<template>
  <div class="loader-generic "></div>
</template>

<script>
export default {
  components: {},
  computed: {},
  created() {},
  data() {
    return {};
  },
  methods: {},
  watch: {},
};
</script>

<style>
.loader-generic {
  border: 16px solid #f3f3f3;
  border-radius: 50%;
  border-top: 16px solid #0064ff;
  border-right: 16px solid transparent;
  border-bottom: 16px solid #0064ff !important;
  border-left: 16px solid transparent;
  width: 100px;
  height: 100px;
  -webkit-animation: spin 2s linear infinite; /* Safari */
  animation: spin 2s linear infinite;
  margin: auto;
}

/* Safari */
@-webkit-keyframes spin {
  0% {
    -webkit-transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
  }
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
